
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { supabase } from "@/integrations/supabase/client";

interface ContactFormProps {
  onSuccess: () => void;
}

export const ContactForm: React.FC<ContactFormProps> = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSending, setIsSending] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSendMessage = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      return;
    }
    
    setIsSending(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('send-contact-email', {
        body: {
          name: formData.name,
          email: formData.email,
          message: formData.message
        }
      });
      
      if (error) {
        throw error;
      }
      
      setFormData({ name: '', email: '', message: '' });
      onSuccess();
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-lg font-medium mb-2 text-primary-dark">Contact Us</h3>
      <form className="w-full max-w-lg" onSubmit={handleSendMessage}>
        <div className="flex flex-col space-y-4">
          <Input 
            placeholder="Provide your name" 
            className="border-primary-dark" 
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <Input 
            placeholder="Provide your email" 
            type="email" 
            className="border-primary-dark"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <Textarea 
            placeholder="Provide your question" 
            className="border-primary-dark h-32"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            required
          />
          <Button 
            type="submit" 
            className="bg-primary hover:bg-primary-dark text-white"
            disabled={isSending}
          >
            {isSending ? 'Sending...' : 'Send Message'}
          </Button>
        </div>
      </form>
    </div>
  );
};
